<ul class="navbar-nav flex-grow">
  @for (item of menuItems(); track item.id) {
  <li class="px-4-cust">
    <a [routerLinkActive]="['link-active']" class="nav-link-cust" [routerLink]="item.navCommands"
      href="javascript:;">{{item.name | uppercase}}</a>
  </li>
  }
</ul>